import {
  AppstoreOutlined,
  BarsOutlined,
  FilterOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Button, DatePicker, Space } from "antd";
import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDistpachStore } from "./dispatch.store";

interface ViewControlsProps {
  viewMode: string;
  selectedDate: string;
  setSelectedDate: (date: string) => void;
  compactView: boolean;
  setCompactView: (compact: boolean) => void;
}

export const ViewControls: React.FC<ViewControlsProps> = ({
  viewMode,
  compactView,
  setCompactView,
}) => {
  const { filters, setFilters } = useDistpachStore();
  const navigate = useNavigate();

  const handleDateChange = (date: dayjs.Dayjs | null) => {
    if (date) {
      setFilters({ startDate: date.toISOString() });
    }
  };

  const handlePrevDay = () => {
    const prevDate = dayjs(filters.startDate).subtract(1, "day");
    setFilters({
      startDate: prevDate.toISOString(),
    });
  };

  const handleNextDay = () => {
    const nextDate = dayjs(filters.startDate).add(1, "day");
    setFilters({
      startDate: nextDate.toISOString(),
    });
  };

  const handleLoadListsClick = () => {
    const dateParam = filters.startDate
      ? dayjs(filters.startDate).format('YYYY-MM-DD')
      : dayjs().format('YYYY-MM-DD');
    navigate(`/dispatch/load-lists?date=${dateParam}`);
  };

  return (
    <div className="bg-white rounded-lg border shadow-sm p-4 mb-6 flex flex-wrap items-center justify-between gap-4">
      <Space>
        {viewMode === "daily" && (
          <Space>
            <Button
              type="text"
              icon={<LeftOutlined />}
              className="p-1 rounded hover:bg-gray-100"
              onClick={handlePrevDay}
            />
            <DatePicker
              value={filters.startDate ? dayjs(filters.startDate) : null}
              onChange={handleDateChange}
              format="DD/MM/YYYY"
              className="px-3 py-1.5 border rounded-lg"
            />
            <Button
              type="text"
              icon={<RightOutlined />}
              className="p-1 rounded hover:bg-gray-100"
              onClick={handleNextDay}
            />
          </Space>
        )}
        <Button
          icon={<FilterOutlined />}
          className="flex items-center space-x-2 px-4 py-2 border rounded-lg hover:bg-gray-50"
        >
          Filters
        </Button>
      </Space>
      <div className="flex items-center space-x-2">
        <span className="text-sm text-gray-600">Quick Actions:</span>
        <Button
          icon={<BarsOutlined />}
          className="flex items-center space-x-2 px-4 py-2 border rounded-lg hover:bg-gray-50"
          onClick={handleLoadListsClick}
        >
          Load Lists
        </Button>
        <Button
          icon={<AppstoreOutlined />}
          className="flex items-center space-x-2 px-4 py-2 border rounded-lg hover:bg-gray-50"
        >
          Export Data
        </Button>
      </div>
    </div>
  );
};
